// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contrast span.badge[data-v-15c416f1]{background-color:none!important;color:#fff!important}.contrast span.badge.new[data-v-15c416f1]{background-color:#fff!important;color:#000!important}", ""]);
// Exports
module.exports = exports;
